export enum ActivityCompensationType {
    OneExcuseForOneCompensation = 0,
    TwoExcusesForOneCompensation = 1,
    CompensationsDisabled = 2
}